import { Action, createReducer, on } from "@ngrx/store";
import { updateFormState } from "../actions/form.actions";

export type FormState = {
  formSetupId?: number;
  formInstanceId?: number;
  parentFormInstanceId?: number;
};

export const initialFormState: FormState = {};

const _formReducer = createReducer(
  initialFormState,
  on(updateFormState, (_state: FormState, newState: FormState) => {
    return { ...newState };
  }),
);

export function formReducer(state: FormState | undefined, action: Action) {
  return _formReducer(state, action);
}
